// extracted by mini-css-extract-plugin
module.exports = {"contactTitle":"DeviceModelSummaryListHeader-module--contactTitle--2o5yG","contactButton":"DeviceModelSummaryListHeader-module--contactButton--3gv50"};